// Fronted/src/components/admin/ui/DatePicker.jsx
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const CustomDatePicker = ({ selected, onChange, ...props }) => {
  return (
    <DatePicker
      selected={selected}
      onChange={onChange}
      className="block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
      {...props}
    />
  );
};

export default CustomDatePicker;